import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

const RETENTION_NOTICE_TEXT =
  'CBC is free and will always remain free for core club features. In the future, we may introduce optional paid plans with expanded history, advanced metrics, and long-term message storage. Free clubs may eventually have message history limited to the most recent 3 months. We\u2019ll notify club owners before any retention changes take effect.';

const MessageHistoryRetentionNotice = ({ compact = false }) => (
  <Paper
    variant="outlined"
    sx={{
      p: compact ? 2 : { xs: 2, md: 3 },
      mb: 2,
      bgcolor: 'background.default',
      borderColor: 'divider',
    }}
  >
    <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
      <InfoOutlined
        color="action"
        sx={{ mt: 0.25, flexShrink: 0, fontSize: compact ? 20 : 22 }}
      />
      <Box>
        <Typography
          variant={compact ? 'subtitle2' : 'h6'}
          sx={{
            mb: 0.75,
            fontWeight: 600,
            fontSize: compact ? undefined : { xs: '1rem', md: '1.25rem' },
          }}
        >
          Message history retention
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {RETENTION_NOTICE_TEXT}
        </Typography>
      </Box>
    </Box>
  </Paper>
);

export default MessageHistoryRetentionNotice;
